/**
 *
 * @param {Array of chip} filters
 * @param {Array of element references} refs
 * @param {chipContainer reference} parentRef
 * @param {number of row to be displayed} maxRows
 * @returns {Object: {
 *  Array of chip to be displayed,
 *  Array of chip to be displayed on action
 *  }}
 */
export const buildChipsArrays = (filters, refs, parentRef, maxRows) => {
  const result = {
    chips: [],
    moreChips: [],
  };

  if (filters?.length > 0 && refs?.length > 0 && parentRef) {
    /**
     * @rowWidth -> chipContainer's width.
     * will be use to be compared with cumulatedChipsWidth
     * to define whether or not chip will be added to current row.
     */
    const rowWidth = parentRef?.current?.clientWidth || 0;
    let rowsNumber = 1;
    let cumulatedChipsWidth = 0;

    if (verifyRefsAreDef(refs) && maxRows > 0) {
      filters.forEach((filter, index) => {
        if (refs[index] && refs[index].current) {
          const parentWidth = refs[index].current?.parentNode.clientWidth;

          /**
           * @textWidth
           * used to define if text is cropped or not.
           */
          const { clientWidth, scrollWidth } = refs[index].current?.children[0];

          /**
           * Check if currentChip should be placed in moreChip array.
           */
          if (cumulatedChipsWidth + parentWidth > rowWidth && rowsNumber >= maxRows) {
            result.moreChips.push({
              ...filter,
              cropped: scrollWidth > clientWidth,
            });
          } else {
            /**
             * @result Chip will be place in chip array.
             * Incrementation of comparaison's values.
             * @case1 rowsNumber increment when chip width added
             * to current row's width is higher than chip container's width.
             * @case2 chip width is added to current row's width
             */
            if (cumulatedChipsWidth + parentWidth > rowWidth) {
              rowsNumber += 1;
              cumulatedChipsWidth = parentWidth;
            } else {
              cumulatedChipsWidth += parentWidth;
            }
            result.chips.push({
              ...filter,
              cropped: scrollWidth > clientWidth,
            });
          }
        } else if (filter) {
          result.chips.push(filter);
        }
      });
    } else {
      result.chips = filters;
    }
  }

  return result;
};

const verifyRefsAreDef = (refs) => {
  let result = true;
  refs.forEach(({ current }) => {
    if (!current || current === null || typeof current.clientWidth !== "number") {
      result = false;
    }
  });

  return result;
};
